import Provider from "../Provider";
import RolesContextType from "./RolesContextType";

export default interface RolesProvider extends Provider<RolesContextType>{
}

export const RolesProviderName = 'RolesProvider';